import { Box, Text, SimpleGrid } from '@chakra-ui/react';
import { MatchCard } from './MatchCard';

interface HighConfidenceMatchesProps {
  matches: any[];
  submittedFaceUrl: string | null;
  API_URL: string;
  onStatsOpen: () => void;
  setSelectedMatchStats: (match: any) => void;
  isSelectable?: boolean;
  selectedMatches?: Set<string>;
  onSelect?: (match: any, selected: boolean) => void;
}

export const HighConfidenceMatches = ({ 
  matches, 
  submittedFaceUrl, 
  API_URL, 
  onStatsOpen, 
  setSelectedMatchStats,
  isSelectable = false,
  selectedMatches = new Set(),
  onSelect
}: HighConfidenceMatchesProps) => {
  const highConfidenceMatches = matches.filter(match => match.similarity >= 0.57);

  if (highConfidenceMatches.length <= 1) {
    return null;
  }

  return (
    <Box w="full">
      <Text fontSize="2xl" fontWeight="bold" color="white" mb={4}>
        High Confidence Matches
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {highConfidenceMatches.slice(1).map((match, index) => (
          <MatchCard
            key={match.image_path}
            match={match}
            submittedFaceUrl={submittedFaceUrl}
            API_URL={API_URL}
            onStatsOpen={onStatsOpen}
            setSelectedMatchStats={setSelectedMatchStats}
            isSelectable={isSelectable}
            isSelected={selectedMatches.has(match.image_path)}
            onSelect={onSelect}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
}; 